import { Builder } from '@builder.io/react'

import BlogPostBody from './blogPostBody'

Builder.registerComponent(BlogPostBody, {
  name: 'ArticleBody',
  inputs: [{ name: 'body', friendlyName: 'text', type: 'richText', defaultValue: '<p>Article body text here...</p>' }],
  noWrap: true,
})
